import axios from '../../libs/cifra/axios';

const URL_ENSENANZA = '/ensennanzas';

export default {
  obtenerConfiguracion(idEnsenanza, options) {
    return axios.get(`${URL_ENSENANZA}/${idEnsenanza}/ensennanza`, options);
  },
};
